import React, {ReactElement, useCallback, useEffect, useState} from 'react';

import {useAppDispatch} from '../../store';
import {Actions} from '../gameSlice';
import {useGameStatus} from '../hooks';
import HarvestReport from './HarvestReport';
import HarvestSummary from './HarvestSummary';
import {SimplePill} from './SimplePill';

export const HARVEST_DURATION = 6600;

const Harvest = (): ReactElement => {
  const dispatch = useAppDispatch();
  const gameStatus = useGameStatus();
  const [step, setStep] = useState<'report' | 'harvesting' | 'summary'>(
    gameStatus.isHarvesting ? 'harvesting' : 'report'
  );

  const handleContinue = useCallback(() => {
    if (step === 'report') {
      setStep('harvesting');
      dispatch(Actions.setIsHarvesting(true));
    } else if (step === 'summary') {
      dispatch(Actions.goToNextYear());
    }
  }, [dispatch, step]);

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>;
    if (step === 'harvesting') {
      timeout = setTimeout(() => {
        setStep('summary');
      }, HARVEST_DURATION);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [dispatch, step]);

  if (step === 'report') return <HarvestReport onContinue={handleContinue} />;
  if (step === 'summary') return <HarvestSummary onContinue={handleContinue} />;
  return <SimplePill className={'mt-4'}>Harvest</SimplePill>;
};

export default Harvest;
